// src/stores/stateErrorMessage.ts
import { defineStore } from 'pinia';

interface StateErrorMessage {
    title?: string;
    message?: string;
    errorCode?: string;
}

export const useStateErrorMessageStore = defineStore('stateErrorMessage', {
    // state 概念同「data」，在此可以使用箭頭函式
    state: (): StateErrorMessage => ({
        title: undefined,
        message: undefined,
        errorCode: undefined
    }),
    // actions 概念同「methods」
    actions: {
        // 可使用 this 使用 state 的資料內容
        setStateErrorMessage(data: StateErrorMessage) {
            this.title = data.title;
            this.message = data.message;
            this.errorCode = data.errorCode;
        },
        clearStateErrorMessage() {
            this.title = undefined;
            this.message = undefined;
            this.errorCode = undefined;
        }
    }
});
